import React from 'react';
import { classNames } from 'helpers';
import './TextField.scss';

const TextField = props => {
  const { type = 'text', name, label, placeholder, className, onChange, onBlur, error } = props;

  const classes = classNames('field', 'textfield', className, { error });
  return (
    <div className={classes}>
      {label && (
        <label htmlFor={name} className="field-label">
          {label}
        </label>
      )}
      <input
        id={name}
        className="field-input"
        type={type}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
      />
      {error && <span className="error">{error}</span>}
    </div>
  );
};

export default TextField;
